export default {
  loading: state => state.loading,
  getVisitFlow: state => state.visitFlow,
  isEditing: state => state.isEditing,
  uuid: state => state.uuid,
  getVisitFlowPayload: state => {
    const visitFlow = state.visitFlow
    const payload = {
      name: visitFlow.title,
      flow: visitFlow.flow,
    }

    return payload
  }
}